// Source: https://raw.githubusercontent.com/react-ga/react-ga/master/demo/app/withTracker.jsx

import React, { Component } from "react";
import ReactGA from "react-ga";

export default function withTracker(WrappedComponent, options = {}) {
    const trackPage = page => {
        ReactGA.set({
            page,
            ...options
        });
        ReactGA.pageview(page);
    };

    const HOC = class extends Component {
        componentDidMount() {
            const page = this.props.location.pathname;
            trackPage(page);
        }

        componentWillReceiveProps(nextProps) {
            const currentPage = this.props.location.pathname;
            const nextPage = nextProps.location.pathname;

            if (currentPage !== nextPage) {
                trackPage(nextPage);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    return HOC;
}



// WEBPACK FOOTER //
// ./src/components/withTracker/index.js